import LifecycleReportingPage from '@/modules/customer-intelligence/pages/LifecycleReportingPage'
import CampaignROIPage from '@/modules/customer-intelligence/pages/CampaignROIPage'
import CustomerIntelligenceDashboardPage from '@/modules/customer-intelligence/pages/CustomerIntelligenceDashboardPage.vue'

export default [
  {
    name: 'CustomerIntelligence',
    path: '/customer-intelligence',
    component: CustomerIntelligenceDashboardPage,
    meta: {
      features: ['intelligenceAccessible']
    }
  },
  {
    name: 'LifecycleReporting',
    path: '/customer-intelligence/lifecycle-reporting',
    component: LifecycleReportingPage
  },
  {
    name: 'CampaignROI',
    path: '/customer-intelligence/campaign-roi',
    component: CampaignROIPage
  }
]



// WEBPACK FOOTER //
// ./src/modules/customer-intelligence/router/index.js